import { GIT_PROVIDERS } from 'common/constants/constants';

const useIsTokenTypeSelectionEnabled = ({ providerId }) => {
  switch (providerId) {
    case GIT_PROVIDERS.GITHUB:
      return true;
    default:
      return false;
  }
};

export default useIsTokenTypeSelectionEnabled;
